import React from 'react'
import { Box, Divider } from '@chakra-ui/react'

const SideNavDivider = () => {
  return (
    <Box px="2" w="full" borderColor="brand.border">
      <Divider />
    </Box>
  )
}

export default SideNavDivider
